import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ContentModelConfigurationPage = lazy(
  () => import('~/features/content/pages/content-model-configuration-page'),
);

/** AI models (formerly Model Configuration) at `/content/settings/models`. */
export const Route = createFileRoute('/_authenticated/_tenant/content/settings/models')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContentModelConfigurationPage />
    </Suspense>
  ),
});
